import { Tabs } from '@tonic/shared/components/ui'
import { TabsList } from '@tonic/shared/components/ui'
import { TabsTrigger } from '@tonic/shared/components/ui'
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../../../utils/cn';
import { 
  LayoutDashboard, 
  Recycle,
  BarChart2, 
  Leaf,
  FileText,
  Settings,
  Banknote,
  Package
} from 'lucide-react';

const subNavigation = [
  {
    name: 'Overview',
    href: '/admin/re-commerce/recycle',
    icon: LayoutDashboard
  },
  {
    name: 'Items',
    href: '/admin/re-commerce/recycle/items',
    icon: Package
  },
  {
    name: 'Program',
    href: '/admin/re-commerce/recycle/program',
    icon: Recycle
  },
  {
    name: 'Analytics',
    href: '/admin/re-commerce/recycle/analytics',
    icon: BarChart2
  },
  {
    name: 'Environment',
    href: '/admin/re-commerce/recycle/environment',
    icon: Leaf
  },
  {
    name: 'Financials',
    href: '/admin/re-commerce/recycle/financials',
    icon: Banknote
  },
  {
    name: 'Information',
    href: '/admin/re-commerce/recycle/information',
    icon: FileText
  }
];

export function RecycleLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { value: 'list', label: 'List', path: '/admin/re-commerce/recycle/items' },
    { value: 'program', label: 'Program', path: '/admin/re-commerce/recycle/program' },
    { value: 'analytics', label: 'Analytics', path: '/admin/re-commerce/recycle/analytics' },
    { value: 'environment', label: 'Environment', path: '/admin/re-commerce/recycle/environment' },
    { value: 'financials', label: 'Financials', path: '/admin/re-commerce/recycle/financials' },
    { value: 'information', label: 'Information', path: '/admin/re-commerce/recycle/information' }
  ];

  const currentTab = tabs.find(tab => 
    location.pathname === tab.path || 
    (tab.value === 'list' && location.pathname === '/admin/re-commerce/recycle')
  )?.value || 'list';

  return (
    <div className="h-full flex flex-col">
      <div className="border-b border-neutral-200 bg-white">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-semibold text-neutral-900">Recycling</h1>
          <p className="text-sm text-neutral-500">Manage recycling programs and track environmental impact</p>
        </div>
        <div className="px-6">
          <Tabs value={currentTab} onValueChange={(value) => {
            const tab = tabs.find(t => t.value === value);
            if (tab) navigate(tab.path);
          }}>
            <TabsList className="border-b-0">
              {tabs.map((tab) => (
                <TabsTrigger
                  key={tab.value}
                  value={tab.value}
                  className={cn(
                    'flex items-center gap-2 px-4 py-2',
                    'transition-colors duration-200'
                  )}
                >
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
      </div>
      <div className="flex-1 overflow-auto bg-neutral-50">
        <Outlet />
      </div>
    </div>
  );
}
